

export const URL_SOCKET = "wss://gjbli04qpd.execute-api.us-east-1.amazonaws.com/production";
export const baseCatalogs = 'https://fumkfk8y9j.execute-api.us-east-1.amazonaws.com';